<template>
  <a-drawer
    title="媒体账号管理"
    width="1000"
    :visible="visible"
    :closable="false"
    :footer="false"
    @close="onClose"
  >
    <div class="tool-view">
      <!-- 弹簧 -->
      <div style="flex: 1;"></div>
      <!-- 添加账号 -->
      <a-button type="primary" @click="touchAdd"><plus-outlined /> 添加账号</a-button>
    </div>
    <!-- 列表 -->
    <a-table
      class="table-view"
      :data-source="dataSource"
      :columns="columns"
      :row-key="record => record.id"
      :pagination="pagination"
      :loading="isLoading"
      @change="handleTableChange"
    >
      <!-- 自定义行内容 -->
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'type'">
          <span>{{ (AccountChannelTypes.find(item => item.value === record.type) || {}).text || '-' }}</span>
        </template>
        <template v-if="column.key === 'attr_type'">
          <span>{{ (AccountTypes.find(item => item.value === record.property) || {}).text || '-' }}</span>
        </template>
        <template v-if="column.key === 'operation'">
          <a class="operation-item" @click="touchEdit(record)">编辑</a>
        </template>
      </template>
    </a-table>
    <!-- 添加 -->
    <AddAccount ref="RefAddAccount" @success="onAddAccountSuccess"></AddAccount>
    <!-- 加载 -->
    <Loading :loading="isSyncAllLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { Modal } from 'ant-design-vue'
import Pub from '@/utils/public'
import { onBeforeMount, reactive, ref, createVNode } from 'vue'
import { nextTick } from 'process'
import AddAccount from './AddAccount.vue'
import { message } from 'ant-design-vue'
import { AccountTypes, ProfitTypes, AccountChannelTypes } from '@/utils/constantList'
import { accountList } from '@/api/copyright'
import Loading from '@/components/Loading'

// emit
const emit = defineEmits(['success'])
// 剧集简介
let RefAddAccount = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
let isSyncAllLoading = ref(false)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 20,
  size: 'small',
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '账号ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '账号名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '媒体',
    dataIndex: 'type',
    key: 'type'
  },
  {
    title: '属性',
    dataIndex: 'attr_type',
    key: 'attr_type'
  },
  {
    title: '创建/购入日期',
    dataIndex: 'date',
    key: 'date'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
  }
])

// 显示
function showDrawer () {
  // 显示
  visible.value = true
  // 延迟处理
  nextTick(() => {
    // 获取列表
    getList()
  })
}

// 关闭
function onClose () {
  if (!isLoading.value) {
    // 重置
    pagination.current = 1
    pagination.pageSize = 20
    visible.value = false
  }
}

// 添加服务商
function touchAdd (record) {
  RefAddAccount.value.showDrawer(record)
}

// 编辑
function touchEdit (record) {
  RefAddAccount.value.showDrawer(record)
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  // 获取列表
  getList()
}

// 添加成功
function onAddAccountSuccess () {
  // 获取列表
  getList()
  // 添加成功回调
  emit('success')
}

// 获取列表
function getList () {
  isLoading.value = true
  const params = {
    page: pagination.current,
    page_size: pagination.pageSize
  }
  accountList(params).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      // 重置列表数据
      dataSource.value = data.data
      pagination.total = data.total
    }
  }).catch(() => {
    isLoading.value = false
  })
}

// 抛出
defineExpose({
  showDrawer
})

</script>

<style scoped>
.tool-view {
  display: flex;
}
.table-view {
  margin-top: 20px;
}

</style>